import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/General/Navbar';
import Footer from './components/General/Footer';
import Home from './pages/Home';
import Machine from './pages/Machine';
import Contact from './pages/Contact';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { Box } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { texts } from './lang';

const AppContent = () => {
  const { language } = useLanguage();
  const { metatitle, metadescription } = texts[language].general;

  // ✅ Titre affiché dans l’onglet (fixé en dur à "1000Shake")
  useEffect(() => {
    document.title = '1000Shake';
  }, []);

  return (
    <>
      <Helmet>
        {/* ✅ Titre pour le SEO / Google */}
        <meta name="title" content={metatitle} />
        <meta property="og:title" content={metatitle} />

        {/* ✅ Description dynamique pour SEO */}
        <meta name="description" content={metadescription} />
        <meta property="og:description" content={metadescription} />

        {/* ✅ Favicon injecté dans le head */}
        <link rel="icon" href="/favicon.png" type="image/png" sizes="48x48" />
      </Helmet>

      <Box display="flex" flexDirection="column" minHeight="100vh" position="relative">
        <Box position="sticky" top="0" zIndex={100}>
          <Navbar />
        </Box>

        <Box as="main" flex="1" display="flex" flexDirection="column" zIndex={1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/machine" element={<Machine />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Box>

        <Box zIndex={10}>
          <Footer />
        </Box>
      </Box>
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;